import type { ZettleSettings } from "@/app/services/generated/zettlesettingsService";
import { integrationsMenu } from "@/app/ui/navigation/integrationsMenu";
import messages from "@/plugins/i18n";
import type { IntegrationMeta } from "@/components/pages/integrations/composables/types";
import img from "@/assets/images/app/integrations/zettle_paypal.png";
import { EnumIntegrationStatus } from "@/components/pages/integrations/types";
import type { LocalDate } from "@js-joda/core";
import {
  ZettleOrderFilter,
  zettleOrderService,
} from "@/app/services/generated/zettleorderService";
import { fillFilterDates } from "@/store/modules/integrationErrorStore";
import type { Maybe } from "@/components/utils/typeHelpers";

export function zettleIsActivated(settings: Maybe<ZettleSettings>) {
  return !!(
    settings &&
    settings.apiClientId &&
    settings.outletId &&
    settings.readOnly.apiKeyLength !== 0
  );
}

export function zettleMeta(settings: Maybe<ZettleSettings>): IntegrationMeta {
  const activated = zettleIsActivated(settings);
  return {
    name: messages.zettle_title,
    description: messages.zettle_card_content,
    integrationRoute: { name: integrationsMenu.zettle },
    miniImg: img,
    img,
    url: messages.zettle_url,
    guideUrl: messages.zettle_guide,
    activated,
    status: activated
      ? EnumIntegrationStatus.active
      : EnumIntegrationStatus.inactive,
  };
}

export async function getZettleOrders(
  fromDate?: LocalDate,
  toDate?: LocalDate
) {
  return (
    await zettleOrderService.getZettleOrdersByFilter(
      fillFilterDates(new ZettleOrderFilter(), fromDate, toDate)
    )
  ).zettleOrders;
}
